/* eslint-disable react/destructuring-assignment, react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';

import {
    commonDefaultProps,
    commonPropTypes,
    concatClassNames,
    ypUtilsToClassNames,
    filterProps,
} from '../../Abstrap/Abstrap';

const propTypes = {
    ...commonPropTypes,
    alt: PropTypes.string,
    sizeFactor: PropTypes.number,
};

const defaultProps = {
    ...commonDefaultProps,
    alt: 'Aucun élément',
    componentClass: 'img',
    sizeFactor: 1,
    src: '/images/pro/illustration/scan-list_empty.svg',
};

const EmptyStateImage = (props) => {
    const classNames = [
        'c-empty-state__img',
        props.className,
        ...ypUtilsToClassNames(props.ypUtils),
    ];
    return (
        <props.componentClass
            className={concatClassNames(classNames)}
            src={props.src}
            alt={props.alt}
            style={{
                width: `${100 * props.sizeFactor}%`,
                height: `${100 * props.sizeFactor}%`,
            }}
            {...filterProps(propTypes, props)}
        />
    );
};

EmptyStateImage.propTypes = propTypes;

EmptyStateImage.defaultProps = defaultProps;

export default EmptyStateImage;
